module.exports = __webpack_public_path__ + "static/media/joining_bonus_mob.6d00afab.webp";